const en_trans_iteminlist = {
    "": "item in supervision",
    detail: "item in detail",
    addsn: "add serial number",

    message: {
        upload: "Download Excel template for Serial Number upload",
        delete_title: "Are you sure you want to delete item in data?",
        delete_text: "Enter reason for deleting item in data",
    },

    error: {
        delete: "Failed to delete item in data",
    },

    success: {
        delete: "Item in data deleted successfully",
    },
}

export default en_trans_iteminlist;